export default {
user:{
    isLoggedIn:false
},
briefs:{},
}